import React from 'react'
import styled from '@emotion/styled'
import { deleteEntry, updateEntryStatus } from '../utils/repoStorage'

const STATUS_CONFIG = {
  draft:     { label: 'Draft',     bg: '#2a2a2a', color: '#9a9a9a' },
  applied:   { label: 'Applied',   bg: '#0d0d1a', color: '#8888e8' },
  interview: { label: 'Interview', bg: '#1a0d1a', color: '#a088e8' },
  offer:     { label: 'Offer',     bg: '#0d1a0d', color: '#7fc97f' },
  rejected:  { label: 'Rejected',  bg: '#1a0d0d', color: '#ff8888' },
}

const Wrapper = styled.div`min-height:100%;background:#0f0f0f;padding:2rem 2rem 3rem`
const Header = styled.div`display:flex;justify-content:space-between;align-items:center;margin-bottom:2rem`
const NewButton = styled.button`background:#1a202c;color:white;border:none;border-radius:6px;padding:.6rem 1.4rem;font-size:.9rem;font-weight:600;cursor:pointer;transition:background .15s;&:hover{background:#2d3748}`
const Grid = styled.div`display:grid;grid-template-columns:repeat(auto-fill,minmax(300px,1fr));gap:1.25rem`
const Card = styled.div`background:#141414;border-radius:10px;border:1px solid #2a2a2a;padding:1.4rem 1.5rem;display:flex;flex-direction:column;gap:.6rem;transition:border-color .15s;cursor:pointer;&:hover{border-color:#3a3a3a}`
const CardTop = styled.div`display:flex;justify-content:space-between;align-items:flex-start`
const StatusBadge = styled.span`font-size:.7rem;font-weight:600;padding:.2rem .6rem;border-radius:9999px;background:${p => STATUS_CONFIG[p.status]?.bg};color:${p => STATUS_CONFIG[p.status]?.color};white-space:nowrap;flex-shrink:0`
const CardMeta = styled.div`font-size:.82rem;color:#7f7f7f`
const CardActions = styled.div`display:flex;gap:.5rem;margin-top:.4rem`
const ActionBtn = styled.button`flex:1;padding:.4rem 0;border-radius:5px;font-size:.8rem;font-weight:500;cursor:pointer;transition:all .15s;border:1px solid ${p => p.variant === 'danger' ? '#6b2a2a' : '#3a3a3a'};background:${p => p.variant === 'danger' ? '#1a0d0d' : '#1a1a1a'};color:${p => p.variant === 'danger' ? '#ff8888' : '#cfcfcf'};&:hover{background:${p => p.variant === 'danger' ? '#250d0d' : '#252525'}}`
const StatusSelect = styled.select`font-size:.75rem;padding:.25rem .4rem;border:1px solid #3a3a3a;border-radius:4px;background:#1a1a1a;color:#cfcfcf;cursor:pointer;outline:none;&:focus{border-color:#8888e8}`

export const RepoView = ({ repo, onOpen, onNew, onRepoChange }) => {
  const entries = Object.values(repo).sort((a, b) => new Date(b.updated) - new Date(a.updated))

  const handleDelete = (e, id) => {
    e.stopPropagation()
    if (!window.confirm('Delete this resume?')) return
    deleteEntry(id)
    const updated = { ...repo }; delete updated[id]; onRepoChange(updated)
  }

  const handleStatusChange = (e, id) => {
    e.stopPropagation()
    const status = e.target.value
    updateEntryStatus(id, status)
    onRepoChange({ ...repo, [id]: { ...repo[id], status } })
  }

  return (
    <Wrapper>
      <Header>
        <h2 style={{ fontSize: '1.5rem', fontWeight: 700, color: '#f2f2f2', margin: 0 }}>Your Resumes</h2>
        <NewButton onClick={onNew}>+ New Resume</NewButton>
      </Header>

      {entries.length === 0 ? (
        <div style={{ textAlign: 'center', padding: '5rem 2rem', color: '#7f7f7f' }}>
          <h3 style={{ fontSize: '1.2rem', marginBottom: '.5rem', color: '#9a9a9a' }}>No resumes yet</h3>
          <p style={{ fontSize: '.9rem' }}>Click "+ New Resume" to generate your first tailored resume.</p>
        </div>
      ) : (
        <Grid>
          {entries.map(entry => (
            <Card key={entry.id} onClick={() => onOpen(entry)}>
              <CardTop>
                <h3 style={{ fontSize: '1.1rem', fontWeight: 700, color: '#f2f2f2', margin: 0 }}>{entry.title || 'Untitled'}</h3>
                <StatusBadge status={entry.status}>{STATUS_CONFIG[entry.status]?.label}</StatusBadge>
              </CardTop>
              <CardMeta>{entry.company}{entry.company && entry.jobTitle ? ' · ' : ''}{entry.jobTitle}</CardMeta>
              <CardMeta>{entry.appliedDate ? `Applied ${new Date(entry.appliedDate).toLocaleDateString()}` : `Updated ${new Date(entry.updated).toLocaleDateString()}`}</CardMeta>
              <CardActions onClick={e => e.stopPropagation()}>
                <StatusSelect value={entry.status} onChange={e => handleStatusChange(e, entry.id)}>
                  {Object.entries(STATUS_CONFIG).map(([s, c]) => <option key={s} value={s}>{c.label}</option>)}
                </StatusSelect>
                <ActionBtn onClick={() => onOpen(entry)}>Open</ActionBtn>
                <ActionBtn variant="danger" onClick={e => handleDelete(e, entry.id)}>Delete</ActionBtn>
              </CardActions>
            </Card>
          ))}
        </Grid>
      )}
    </Wrapper>
  )
}
